//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { afterNextRender } from "@polymer/polymer/lib/utils/render-status.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import "@polymer/iron-ajax";

import "../../../components/desktop/shared/Modal";
import "../../../components/shared/FaqCard/FaqCard";
import "../../../components/desktop/ecourse/EcourseListTopik/EcourseListTopik";
import "../../../components/desktop/ecourse/EcourseListNarasumber/EcourseListNarasumber";
import "../../../components/desktop/shared/GeneralToast";
import "../../../components/desktop/ecourse/VideoPlayer/VideoPlayer";
import General from "../../../utils/General";
import Alodokter from "../../../utils/Alodokter";
import EcourseAnalytics from "../../../analytics/EcourseAnalytics";

import { _checkStatusRegister, _isShowSponsoreChannel, _sponsoreChannelName, _sponsoreChannelCategory, _sponsoreChannelLogo, _formattedSpesialisasi, _checkExpDate, _checkPoint, _checkPassedEcourse, _checkModulProgress, _checkInitialModulProgress } from "../../../utils/ecourse";

import iconVideoBlack from "../../../images/icons/icon_video_black.svg";
import iconExpBlack from "../../../images/icons/icon_exp_black.svg";
import iconModuleBlack from "../../../images/icons/icon_module_black.svg";
import iconTimeBlack from "../../../images/icons/icon_time_black.svg";
import iconSkp from "../../../images/icons/icon_badge_skp.svg";
import iconAp from "../../../images/icons/icon_poin_ap.svg";
import iconPlusWhite from "../../../images/icons/icon_plus_white.svg";
import iconArrowUpBlue from "../../../images/icons/icon_arrow_up_blue.svg";
import iconArrowDownBlue from "../../../images/icons/icon_arrow_down_blue.svg";
import iconChecklistBlack from "../../../images/icons/icon_circlechecklist_black.svg";
import GeneralAnalytics from "../../../analytics/GeneralAnalytics";
import VideoPlayerAnalytics from "../../../analytics/VideoPlayerAnalytics";

class DetailPage extends PolymerElement {
  static get template() {
    return html`
      <style>
        .container {
          display: flex;
          flex-direction: column;
        }
        .container-row {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          word-wrap: anywhere;
        }
        .title-text {
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          color: #000000;
          margin: 0;
          margin-top: 24px;
        }
        .container-main {
          display: flex;
          width: 660px;
          flex-direction: column;
          margin-bottom: 60px;
        }
        .container-side {
          display: flex;
          flex: 1;
          flex-direction: column;
        }
        .container-sponsor {
          display: flex;
          flex: 1;
          border-top: 1px solid #ececec;
          border-bottom: 1px solid #ececec;
          align-items: center;
          margin-top: 24px;
          padding: 15px 0px;
        }
        .container-sponsor img {
          width: 40px;
          height: 40px;
          border: 1px solid #d9d9d9;
          border-radius: 60px;
          margin-right: 8px;
        }
        .container-sponsor p {
          margin: 0;
          font-weight: 600;
          font-size: 14px;
          line-height: 135%;
          color: #7f7f7f;
        }
        .container-sponsor h4 {
          margin: 0;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #424242;
        }
        .container-content {
          display: flex;
          flex-direction: column;
          margin-top: 12px;
          border-bottom: 1px solid #ececec;
          padding-bottom: 16px;
        }
        .container-content h1 {
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          color: #424242;
          margin: 0;
        }
        .container-content p {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #7f7f7f;
          margin: 0;
        }
        .container-content .content-text {
          display: flex;
          margin-top: 10px;
          align-items: center;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #424242;
        }
        .container-content .content-text img {
          width: 20px;
          height: 20px;
          margin-bottom: 4px;
          margin-right: 4px;
        }
        .container-content .content-point {
          display: flex;
          margin-top: 8px;
          align-items: center;
        }
        .container-content .content-point img {
          margin-right: 4px;
          margin-bottom: 4px;
        }
        .container-content .content-point .text-skp {
          display: flex;
          align-items: center;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #f5a623;
          margin-right: 16px;
        }
        .container-content .content-point .text-ap {
          display: flex;
          align-items: center;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #3570d2;
        }
        .container-description {
          display: flex;
          flex-direction: column;
          margin-top: 16px;
        }
        .container-description h2 {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #424242;
          margin: 0;
        }
        .container-description .content-html {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-height: 24px;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #424242;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 10;
          -webkit-box-orient: vertical;
        }
        .container-description .show-all-html {
          max-height: 100% !important;
          overflow: visible !important;
          -webkit-line-clamp: unset !important;
        }
        .container-description .constant-full-show {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          color: #3570d2;
          cursor: pointer;
          margin-top: 12px;
        }
        .container-price {
          display: flex;
          flex-direction: column;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          padding: 0px 16px;
          margin-left: 20px;
          margin-top: 20px;
          margin-bottom: 16px;
        }
        .container-price h3 {
          margin: 0;
          margin-top: 23px;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #000000;
        }
        .container-price h2 {
          margin: 0;
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          color: #ed6700;
          margin-top: 16px;
        }
        .container-price .button-buy {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 12px 16px 12px 12px;
          background-color: #ed6700;
          border-radius: 8px;
          margin-top: 24px;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #ffffff;
          cursor: pointer;
        }
        .container-price .button-faq {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 12px 16px 12px 12px;
          background-color: #ffffff;
          border-radius: 8px;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #3570d2;
          cursor: pointer;
        }
        .container-disclaimer {
          margin-left: 20px;
        }
        .container-topik {
          margin-top: 36px;
        }
        .container-topik h3 {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #424242;
          margin: 0;
        }
        .container-narasumber {
          margin-top: 36px;
        }
        .container-narasumber h3 {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #424242;
          margin: 0;
        }
        .container-guide {
          margin-top: 36px;
        }
        .container-guide h3 {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #424242;
          margin-bottom: 8px;
        }
        .container-publish-date {
          margin-top: 36px;
        }
        .container-publish-date h3 {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #424242;
          margin: 0 0 8px 0;
        }
        .content-card-register {
          display: flex;
          justify-content: center;
          padding: 12px;
          background: #3570D2;
          border: 1px solid #3570D2;
          border-radius: 4px;
          margin-top: 16px;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #FFFFFF;
          cursor: pointer;
        }
        .html-guide {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #424242;
        }
        .html-publish-date {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #424242;
        }
      </style>
      <iron-ajax
          id="_registerBtn"
          method="POST"
          url = "/api/general/ecourses/register"
          handle-as="json"
          on-response="_handleRegisterResponse"
          debounce-duration="300">
      </iron-ajax> 
      <div class="container">
        <h1 class="title-text">Rincian Materi E-Course</h1>
        <div class="container-row">
          <div class="container-main">
          <video-player
            url-video="{{detail.video_url}}" 
            url-banner="{{detail.thumbnail_url}}"
            on-player="_handleListenerPlayer"
            on-tracking-progress-recording="_handleTrackingRecording"
            id="ecourse-video-player">
          </video-player>
            <template is="dom-if" if="{{_isShowSponsoreChannel(detail)}}">
              <div class="container-sponsor">
                <img src="{{_sponsoreChannelLogo(detail)}}" />
                <div>
                  <p>{{_sponsoreChannelCategory(detail)}}</p>
                  <h4>{{_sponsoreChannelName(detail)}}</h4>
                </div>
              </div>
            </template>
            <div class="container-content">
              <h1>{{detail.title}}</h1>
              <p>{{_formattedSpesialisasi(detail.field_list)}}</p>
              <template is="dom-if" if="{{_checkExpDate(detail.expired_date)}}">
                <div class="content-text">
                  <img src="{{detail.doctor_organization.logo}}" /> {{detail.doctor_organization.name}} | 
                  <img src="{{iconExpBlack}}" style="margin-left: 10px" /> {{detail.expired_date}} | 
                  <img src="{{iconModuleBlack}}" style="margin-left: 10px" /> {{detail.total_module}} | 
                  <img src="{{iconTimeBlack}}" style="margin-left: 10px" /> {{detail.duration}}
                </div>
              </template>
              <template is="dom-if" if="{{!_checkExpDate(detail.expired_date)}}">
                <div class="content-text">
                  <img src="{{detail.doctor_organization.logo}}" /> {{detail.doctor_organization.name}} | 
                  <img src="{{iconModuleBlack}}" style="margin-left: 10px" /> {{detail.total_module}} | 
                  <img src="{{iconTimeBlack}}" style="margin-left: 10px" /> {{detail.duration}}
                </div>
              </template>
              <div class="content-point">
                <template is="dom-if" if="{{_checkPoint(detail.skp_point)}}">
                  <div class="text-skp"><img src="{{iconSkp}}" /> +{{formattedSkpPoint(detail.skp_point)}} SKP</div>
                </template>
                <template is="dom-if" if="{{_checkPoint(detail.alo_point)}}">
                  <div class="text-ap"><img src="{{iconAp}}" /> +{{detail.alo_point}} AP</div>
                </template>
              </div>
            </div>
            <div class="container-description">
              <h2>Tentang Pelatihan</h2>
              <div id="html-content" class="content-html" inner-h-t-m-l="{{detail.description}}"></div>
              <template is="dom-if" if="{{isShowButtonMore}}">
                <template is="dom-if" if="{{!isShowDescription}}">
                  <div on-click="showAllDescription" class="constant-full-show">
                    Selengkapnya
                    <img
                      src="[[iconArrowDownBlue]]"
                      style="margin-top: 3px;"
                    />
                  </div>
                </template>
                <template is="dom-if" if="{{isShowDescription}}">
                  <div on-click="showAllDescription" class="constant-full-show">
                    Sembunyikan
                    <img
                      src="[[iconArrowUpBlue]]"
                      style="margin-top: 3px;"
                    />
                  </div>
                </template>
              </template>
            </div>
            <div class="container-topik">
              <h3>Topik Modul</h3>
              <ecourse-list-topik list-topik="{{detail.modules.list}}" user-status="{{detail.user_status}}" ecourse-analytic="{{getEcourseAnalyticForModule()}}" ecourse-id = {{detail.id}} ></ecourse-list-topik>
            </div>
            <template is="dom-if" if="{{isShowSpeakerList}}">
              <div class="container-narasumber">
                <h3>Daftar Narasumber</h3>
                <ecourse-list-narasumber list-narasumber="{{detail.speaker_list}}"></ecourse-list-narasumber>
              </div>
            </template>
            <template is="dom-if" if="{{isShowGuideDescription}}">
              <div class="container-guide">
                <h3>Cara Mengikuti E-Course</h3>
                <div class="html-guide" inner-h-t-m-l="{{detail.guide_description}}"></div>
              </div>
            </template>
            <div class="container-publish-date">
              <h3>Tanggal Tayang</h3>
              <div class="html-publish-date">{{detail.published_date}}</div>
            </div>
          </div>
          <div class="container-side">
            <div class="container-price">
              <template is="dom-if" if="{{!isRegistered}}" >
                <template is="dom-if" if="{{detail.is_paid}}">
                  <h3>Harga Pendaftaran</h3>
                  <h2>{{detail.payment_info.normal_price}}</h2>
                  <div class="button-buy" on-click="onNavigateCheckout">
                    <img
                      src="[[iconPlusWhite]]"
                      style="margin-bottom: 3px;"
                    />
                    Beli E-Course
                  </div>
                </template>
                <template is="dom-if" if="{{!detail.is_paid}}">
                  <div class="button-buy" on-click="_registerBtnHandler">
                    <img
                      src="[[iconPlusWhite]]"
                      style="margin-bottom: 3px;"
                    />
                    Daftar
                  </div>
                </template>
              </template>
              <template is="dom-if" if="{{isRegistered}}">
                <template is="dom-if" if="{{_checkPassedEcourse(detail.user_status)}}">
                  <div class="content-card-register" on-click="btnRedirectToCertificate">
                    Lihat Sertifikat
                  </div>
                </template>
                <template is="dom-if" if="{{_checkModulProgress(detail.user_status)}}">
                  <div class="content-card-register" on-click="btnContinueProgressModule">
                    Mulai Lihat Modul
                  </div>
                </template>
                <template is="dom-if" if="{{_checkInitialModulProgress(detail.user_status)}}">
                  <div class="content-card-register" on-click="btnContinueProgressModule">
                  Lanjut Modul
                  </div>
                </template>
              </template>
              <div on-click="onShowModalFaq" class="button-faq">FAQ</div>
            </div>
          </div>
        </div>
        <modal-container id="modal-faq" title="FAQ">
          <dom-repeat items="{{listFaqs}}" as="listFaq" slot="child-component">
            <template>
                <faq-card list-faq="{{listFaq}}" slot="child-component"></faq-card>>
            </template
          </dom-repeat>
        </modal-container>
        <general-toast
          is-active="[[isShowToast]]"
          title="Pendaftaran Berhasil"  
          body="Sekarang Anda dapat mengakses semua materi {{detail.title}}."
          color="green"
          is-show-top-text="true"
        >
        </general-toast>
      </div>
    `;
  }

  static get properties() {
    return {
      isLogin: {
        type: Number,
      },
      userUid: {
        type: String,
      },
      detail: {
        type: Object,
      },
      listFaqs: {
        type: Array,
      },
      iconVideoBlack: {
        type: String,
        value: iconVideoBlack,
      },
      iconExpBlack: {
        type: String,
        value: iconExpBlack,
      },
      iconModuleBlack: {
        type: String,
        value: iconModuleBlack,
      },
      iconTimeBlack: {
        type: String,
        value: iconTimeBlack,
      },
      iconSkp: {
        type: String,
        value: iconSkp,
      },
      iconAp: {
        type: String,
        value: iconAp,
      },
      iconPlusWhite: {
        type: String,
        value: iconPlusWhite,
      },
      iconArrowUpBlue: {
        type: String,
        value: iconArrowUpBlue,
      },
      iconArrowDownBlue: {
        type: String,
        value: iconArrowDownBlue,
      },
      iconChecklistBlack: {
        type: String,
        value: iconChecklistBlack,
      },
      isShowMore: {
        type: Boolean,
        value: false,
      },
      isShowDescription: {
        type: Boolean,
        value: false,
      },
      isShowButtonMore: {
        type: Boolean,
        value: false,
      },
      isShowToast: {
        type: Boolean,
        value: false,
      },
      isShowSpeakerList: {
        type: Boolean,
        value: false,
      },
      isShowGuideDescription: {
        type: Boolean,
        value: false,
      },
      isRegistered: {
        type: Boolean,
        value: false,
      },
      isVideoError: {
        type: Boolean,
        value: false,
      },
      _checkStatusRegister: {
        type: Function,
        value: () => _checkStatusRegister,
      },
      _isShowSponsoreChannel: {
        type: Function,
        value: () => _isShowSponsoreChannel,
      },
      _sponsoreChannelName: {
        type: Function,
        value: () => _sponsoreChannelName,
      },
      _sponsoreChannelCategory: {
        type: Function,
        value: () => _sponsoreChannelCategory,
      },
      _sponsoreChannelLogo: {
        type: Function,
        value: () => _sponsoreChannelLogo,
      },
      _formattedSpesialisasi: {
        type: Function,
        value: () => _formattedSpesialisasi,
      },
      _checkExpDate: {
        type: Function,
        value: () => _checkExpDate,
      },
      _checkPoint: {
        type: Function,
        value: () => _checkPoint,
      },
      _checkPassedEcourse: {
        type: Function,
        value: () => _checkPassedEcourse,
      },
      _checkModulProgress: {
        type: Function,
        value: () => _checkModulProgress,
      },
      _checkInitialModulProgress: {
        type: Function,
        value: () => _checkInitialModulProgress,
      },
      trackingVdStartGA4: {
        type: Boolean,
        value: true,
      },
      formattedSkpPoint: {
        type: Function,
        value: () => General.formattedSkpPoint,
      },
    };
  }

  ready() {
    super.ready();
    if (this.isLogin == 1 && General.getCookie("new_alomedika_logged_in") == undefined) {
      window.location.reload();
      this.isLogin = 0;
    }
    const data = this.$["html-content"];
    if (data.innerText.length > 500) {
      this.isShowButtonMore = true;
    } else {
      this.$["html-content"].classList.add("show-all-html");
    }
    if (this.detail.speaker_list.length > 0) this.isShowSpeakerList = true;
    if (this.detail.guide_description != "") this.isShowGuideDescription = true;
    this.isRegistered = _checkStatusRegister(this.detail.user_status);
    afterNextRender(this, function () {
      this.sendGaEventDetailPageView();
      this.sendGA4EcourseViewItem();
    });
  }

  showAllDescription() {
    if (!this.isShowDescription) {
      this.$["html-content"].classList.add("show-all-html");
      this.isShowDescription = true;
      this.sendGaEventSeeMore();
    } else {
      this.isShowDescription = false;
      this.$["html-content"].classList.remove("show-all-html");
    }
  }

  onShowModalFaq() {
    if (!this.isVideoError) {
      const player = videojs(this.shadowRoot.querySelector("#ecourse-video-player").$.ecourse_video_player);
      player.pause();
    }
    this.shadowRoot.querySelector("#modal-faq").activate();
    this.sendGaEventShowModalFaq();
    GeneralAnalytics.faq("ecourse", "detail");
  }

  onNavigateCheckout() {
    if (this.isLogin) {
      window.location = `/payment/list/ecourse?id=${this.detail.id}`;
    } else {
      const player = videojs(this.shadowRoot.querySelector("#ecourse-video-player").$.ecourse_video_player);
      player.pause();
      $("#entrance-overlay").css("display", "block");
    }
    this.sendGaEventRegisterWebinarPaid();
    this.sendGA4EcourseAddToCart();
  }

  _registerBtnHandler(e) {
    e.stopPropagation();
    const registerUser = { id: this.detail.id, user_uid: this.userUid };
    this.$._registerBtn.params = registerUser;
    this.$._registerBtn.generateRequest();
    this.sendGaEventRegisterWebinarFree();
    this.sendGA4EcourseAddToCart();
  }

  _handleRegisterResponse(e) {
    const response = e.detail.response;

    if (response.status == 200) {
      this.isShowToast = true;
      this.isRegistered = true;
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else if (response.status == 500) {
      null;
    } else {
      if (!response.isEmailValid) {
        const player = videojs(this.shadowRoot.querySelector("#ecourse-video-player").$.ecourse_video_player);
        player.pause();
        $("#entrance-overlay").css("display", "block");
      }
    }
  }

  sendGaEventDetailPageView() {
    // Tracker Payment final status is Loaded
    var additionalTracker = this.getAdditonalTracker();
    const sourceUrl = window.location.href;
    let category = this.detail.field_list.map((item) => item.name).join();
    let ecourseType = this.detail.is_paid ? "paid" : "free";
    const eventLabel = `${additionalTracker}ecourse_title: ${this.detail.title} | ecourse_category: ${category} | ecourse_type: ${ecourseType} | source url: ${sourceUrl} | device_category: desktop`;
    Alodokter.sendEventGA("ecourse detail page", "ecourse_detail_viewed", eventLabel);
  }

  sendGA4EcourseViewItem() {
    const dataToSend = {
      ecourse: this.detail,
      is_registered: this.isRegistered,
    };
    EcourseAnalytics.viewItem(dataToSend);
  }

  sendGaEventSeeMore() {
    // Tracker Payment final status is Loaded
    var additionalTracker = this.getAdditonalTracker();
    let category = this.detail.field_list.map((item) => item.name).join();
    let ecourseType = this.detail.is_paid ? "paid" : "free";
    const eventLabel = `${additionalTracker}ecourse_title: ${this.detail.title} | ecourse_category: ${category} | ecourse_type: ${ecourseType} | device_category: desktop`;
    Alodokter.sendEventGA("ecourse detail page", "ecourse_description_more_clicked", eventLabel);
  }

  sendGaEventShowModalFaq() {
    // Tracker Payment final status is Loaded
    var additionalTracker = this.getAdditonalTracker();
    let category = this.detail.field_list.map((item) => item.name).join();
    let ecourseType = this.detail.is_paid ? "paid" : "free";
    const eventLabel = `${additionalTracker}ecourse_title: ${this.detail.title} | ecourse_category: ${category} | ecourse_type: ${ecourseType} | device_category: desktop`;
    Alodokter.sendEventGA("ecourse detail page", "ecourse_faq_popup_viewed", eventLabel);
  }

  sendGaEventRegisterWebinarFree() {
    // Tracker Payment final status is Loaded
    var additionalTracker = this.getTrackingUserUid();
    let category = this.detail.field_list.map((item) => item.name).join();
    const eventLabel = `${additionalTracker}ecourse_title: ${this.detail.title} | ecourse_category: ${category} | ecourse_type: free | device_category: desktop`;
    Alodokter.sendEventGA("ecourse detail page", "ecourse_enroll_free_clicked", eventLabel);
  }

  sendGaEventRegisterWebinarPaid() {
    // Tracker Payment final status is Loaded
    const additionalTracker = this.getTrackingUserUid();
    const category = this.detail.field_list.map((item) => item.name).join();
    const eventLabel = `${additionalTracker}ecourse_title: ${this.detail.title} | ecourse_category: ${category} | ecourse_type: paid | device_category: desktop`;
    Alodokter.sendEventGA("ecourse detail page", "ecourse_enroll_paid_clicked", eventLabel);
  }

  sendGA4EcourseAddToCart() {
    EcourseAnalytics.addToCart(this.detail);
  }

  getAdditonalTracker() {
    var additionalTracker = this.getTrackingUserUid();
    if (additionalTracker) {
      let userStatus = !this.detail.user_status ? "not_enrolled" : "enrolled";
      additionalTracker = `${additionalTracker}ecourse_enrollment_status: ${userStatus} | `;
    }
    return additionalTracker;
  }

  getTrackingUserUid() {
    return this.userUid && this.isLogin ? `user_uid: ${this.userUid} | ` : "";
  }

  _handleListenerPlayer(e, data) {
    /** data -> pause, play, autoplay, ended */
    if (data == "play") {
      this.sendGAPreviewStart();
      if (this.trackingVdStartGA4) {
        VideoPlayerAnalytics.vdStart(this.detail, "ecourse", "ecourse");
        this.trackingVdStartGA4 = false;
      }
    } else if (data == "ended") {
      this.sendGAPreviewFinish();
      VideoPlayerAnalytics.vdFinished(this.detail, "ecourse", "ecourse");
    } else if (data == "error") {
      this.isVideoError = true;
    }
  }

  sendGAPreviewStart() {
    const ecourse = this.detail;
    const ecourseType = ecourse.is_paid ? "paid" : "free";
    const ecourseEnrollmentStatus = ecourse.user_status ? "enrolled" : "not_enrolled";
    const isLogin = this.isLogin == 1 ? true : false;
    const channel = ecourse.channel ? ecourse.channel.type : "";
    const ecourseCategory = ecourse.field_list.map((item) => item.name).join();
    const userUid = this.getTrackingUserUid();
    const eventLabel = `${userUid}ecourse_title: ${ecourse.title} | ecourse_category: ${ecourseCategory} | ecourse_type: ${ecourseType} | ecourse_enrollment_status: ${ecourseEnrollmentStatus} | is_login: ${isLogin} | device_category: web | channel_type: ${channel}`;
    Alodokter.sendEventGA("watch ecourse preview", "ecourse_preview_start", eventLabel);
  }

  sendGAPreviewFinish() {
    const ecourse = this.detail;
    const ecourseType = ecourse.is_paid ? "paid" : "free";
    const ecourseEnrollmentStatus = ecourse.user_status ? "enrolled" : "not_enrolled";
    const isLogin = this.isLogin == 1 ? true : false;
    const channel = ecourse.channel ? ecourse.channel.type : "";
    const ecourseCategory = ecourse.field_list.map((item) => item.name).join();
    const userUid = this.getTrackingUserUid();
    const eventLabel = `${userUid}ecourse_title: ${ecourse.title} | ecourse_category: ${ecourseCategory} | ecourse_type: ${ecourseType} | ecourse_enrollment_status: ${ecourseEnrollmentStatus} | is_login: ${isLogin} | device_category: web | channel_type: ${channel}`;
    Alodokter.sendEventGA("watch ecourse preview", "ecourse_preview_finish", eventLabel);
  }

  btnContinueProgressModule() {
    this.sendGA4EcourseBeginLearn();
    window.location = window.location.origin + `/skp/${this.detail.modules.onprogress_module_id}`;
    this.sendGASideEcourseButton();
  }

  btnRedirectToCertificate() {
    this.sendGA4EcourseBeginLearn();
    window.location = window.location.origin + `/certificate/${this.detail.certificate_id}`;
    this.sendGASideEcourseButton();
  }

  sendGASideEcourseButton() {
    const ecourse = this.detail;
    const eventActionSideButtonStr = this.getEventActionSideButton(ecourse.user_status);
    const userUid = this.getTrackingUserUid();
    const ecourseCategory = ecourse.field_list.map((item) => item.name).join();
    const ecourseType = ecourse.is_paid ? "paid" : "free";
    const sourceUrl = window.location.href;
    const eventLabel = `${userUid}ecourse_title: ${ecourse.title} | ecourse_category: ${ecourseCategory} | ecourse_type: ${ecourseType} | device_category:  desktop | source url: ${sourceUrl}`;
    Alodokter.sendEventGA("ecourse detail page", eventActionSideButtonStr, eventLabel);
  }

  sendGA4EcourseBeginLearn() {
    EcourseAnalytics.beginLearn(this.detail);
  }

  getEventActionSideButton(userStatus) {
    if (this._checkPassedEcourse(userStatus)) {
      return "ecourse_get_certificate";
    } else if (this._checkModulProgress(userStatus)) {
      return "ecourse_start_module";
    } else if (this._checkInitialModulProgress(userStatus)) {
      return "ecourse_continue_module";
    }
    return "";
  }

  getEcourseAnalyticForModule() {
    var ecourseAnalyticForModuleObj = {};
    ecourseAnalyticForModuleObj.userUid = this.getTrackingUserUid();
    ecourseAnalyticForModuleObj.title = this.detail.title;
    ecourseAnalyticForModuleObj.category = this.detail.field_list.map((item) => item.name).join();
    ecourseAnalyticForModuleObj.ecourseType = this.detail.is_paid ? "paid" : "free";
    return ecourseAnalyticForModuleObj;
  }

  _handleTrackingRecording(e, data) {
    VideoPlayerAnalytics.vdProgress(this.detail, "ecourse", "ecourse", data);
  }
}

customElements.define("detail-page", DetailPage);
